module.exports = fox._r("images/tips-options-bg.jpg", __webpack_public_path__ + "images/tips-options-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/tips-options-bg.jpg
// module id = 1025
// module chunks = 4